import buildItemComponent from "../../common/item-component-hoc"

import ViewFeedFormActionButtonsWidgetContainer from "./view/ViewFeedFormActionButtonsWidgetContainer"
import ViewFeedItemDetailsContainer from "./view/ViewFeedItemDetailsContainer"
import EditFeedFormActionButtonsWidgetContainer from "./edit/EditFeedFormActionButtonsWidgetContainer"
import EditFeedItemDetailsContainer from "./edit/EditFeedItemDetailsContainer"

const Feed = buildItemComponent("feed", {
    view: [
        ViewFeedFormActionButtonsWidgetContainer,
        ViewFeedItemDetailsContainer
    ],
    edit: [
        EditFeedFormActionButtonsWidgetContainer,
        EditFeedItemDetailsContainer
    ]
})

export default Feed
